import React, { useState, useCallback, useMemo } from 'react';
import { DownloadModal } from '../components/UI/Modals/DownloadModal';

export const useDownloadJSONModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const openDownloadModal = useCallback(() => setIsVisible(true), []);
  const closeDownloadModal = useCallback(() => setIsVisible(false), []);

  const DownloadModalComponent = useMemo(() => {
    const Component = React.memo(
      ({ setMessageHandler }: { setMessageHandler: (message: string) => void }) => {
        return (
          <DownloadModal
            isVisible={isVisible}
            onClose={closeDownloadModal}
            setMessageHandler={setMessageHandler}
          />
        );
      }
    );
    Component.displayName = 'DownloadModalComponent';
    return Component;
  }, [isVisible, closeDownloadModal]);

  return {
    openDownloadModal,
    DownloadModal: DownloadModalComponent,
  };
};
